import { Description, Form, FormButton, Title, Wrapper } from '../../style';

import Input from '../../../../components/Input';
import { useNavigate } from 'react-router-dom';

const Password = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Title>Password</Title>
      <Description>
        Datox seamlessly integrates data from various sources, including databases, APIs, and
        external applications
      </Description>

      <Form>
        <Input label="Password" placeholder="Type your password" type="password" />
        <Input label="Confirm your password" placeholder="Type your password" type="password" />
        <FormButton maxWidth={true} type="button" onClick={() => navigate('/avatar')}>
          Continue
        </FormButton>
      </Form>
    </Wrapper>
  );
};

export default Password;
